cobalt-textarea {
  display: block;
}

cobalt-textarea .icon-box {
  padding: var(--number-spacing-none);
}

cobalt-textarea .textarea-format--aside .textarea-header {
  min-height: 2.25rem;
}
